import ContentTemplateCollectionsTab from 'src/components/pages/Content/ContentTemplatePage/ContentTemplateCollectionsTab/ContentTemplateCollectionsTab';

export default ContentTemplateCollectionsTab;
